import { instance } from './config';
import bcrypt from 'bcryptjs';

export const login = (username, password) => {
   return instance.post('/authenticate/login/', {
      username: username,
      password: password,
   });
};

export const getAllUsers = () => {
   return instance.get('/user');
};

export const getUserById = (userId) => {
   return instance.get(`/user/${userId}`);
};

export const createUser = (requestData) => {
   return instance.post('/user', requestData);
};

export const editUser = (requestData) => {
   return instance.put('/user', requestData);
};

export const isAdmin = () => {
   if (localStorage.getItem('roles')) {
      const roles = JSON.parse(localStorage.getItem('roles'));
      return roles.filter((item) => item.roleId === 1).length > 0;
   }
   return false;
};

export const isManager = () => {
   if (localStorage.getItem('roles')) {
      const roles = JSON.parse(localStorage.getItem('roles'));
      return roles.filter((item) => item.roleId === 4).length > 0;
   }
   return false;
};

export const encryptPassword = (password) => {
   let salt = bcrypt.genSaltSync(10);
   const hashedPassword = bcrypt.hashSync(password, salt);
   return hashedPassword;
};
